var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.6 16.1",
    style: {
      enableBackground: "new 0 0 18.6 16.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFA50D;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.95 -61.95)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,78c-1.3,0-2.3-1.1-2.3-2.4v-8.4c0-1.3,1-2.4,2.3-2.4h2.1c0.1,0,0.1-0.1,0.2-0.2l0.5-1.7 c0.2-0.5,0.6-0.9,1.2-0.9l6,0c0.6,0,1,0.4,1.2,0.9l0.5,1.8c0,0.1,0.1,0.1,0.2,0.1l2.1,0c1.3,0.1,2.3,1.1,2.3,2.4v8.4 c0,1.3-1,2.4-2.3,2.4H24.2z M34.2,63l-5.9,0c-0.1,0-0.1,0.1-0.2,0.2l-0.5,1.7c-0.2,0.5-0.6,0.9-1.2,0.9l-2.1,0 c-0.7,0-1.2,0.6-1.2,1.3v8.5c0,0.7,0.5,1.3,1.2,1.3h14c0.7,0,1.2-0.6,1.2-1.3v-8.5c0-0.7-0.5-1.3-1.2-1.3h-2.1 c-0.6,0-1-0.4-1.2-0.9l-0.5-1.8C34.4,63.1,34.3,63.1,34.2,63z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.875 66.875)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 3.8,
    cy: 3.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.7,7.5C1.7,7.5,0,5.8,0,3.7S1.7,0,3.7,0s3.7,1.7,3.7,3.7S5.8,7.5,3.7,7.5z M3.7,1.1c-1.5,0-2.6,1.2-2.6,2.6 s1.2,2.7,2.6,2.7s2.7-1.2,2.7-2.7S5.2,1.1,3.7,1.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.a86d0531.svg";
export { ForwardRef as ReactComponent };